import React from 'react';

const PrivacyBanner = () => {
    return (
        <div className='heights'>
        <img src="https://i.ibb.co/TwyBZpZ/Frame-13-1.png" alt="" />
       </div>
    );
};

export default PrivacyBanner;